const KEY_ALGORITHM = "ECDH-P256";
const ENCRYPTION_ALGORITHM = "ECDH-P256-AES256GCM";
const ENCRYPTION_VERSION = 1;
const ENCRYPTION_VERSION_2 = 2;
function isEncryptedProcessVariable(value) {
  if (typeof value !== "object" || value === null || !("_encrypted" in value) || value._encrypted !== true || !("version" in value) || !("algorithm" in value) || !("payload" in value)) {
    return false;
  }
  const v = value;
  if (v.version === ENCRYPTION_VERSION) {
    return "keySlots" in value;
  }
  if (v.version === ENCRYPTION_VERSION_2) {
    return "authoritySlots" in value;
  }
  return false;
}
function isEncryptedProcessVariableV1(value) {
  return isEncryptedProcessVariable(value) && value.version === ENCRYPTION_VERSION && "keySlots" in value;
}
function isEncryptedProcessVariableV2(value) {
  return isEncryptedProcessVariable(value) && value.version === ENCRYPTION_VERSION_2 && "authoritySlots" in value;
}
class EncryptionError extends Error {
  constructor(message, code, cause) {
    super(message);
    this.code = code;
    this.cause = cause;
    this.name = "EncryptionError";
  }
}
export {
  ENCRYPTION_ALGORITHM,
  ENCRYPTION_VERSION,
  ENCRYPTION_VERSION_2,
  EncryptionError,
  KEY_ALGORITHM,
  isEncryptedProcessVariable,
  isEncryptedProcessVariableV1,
  isEncryptedProcessVariableV2
};
//# sourceMappingURL=index.js.map
